module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABX0lEQVRYR+2XsUoDQRCG/z+XLlr6BoqYXlGwttPG2Cja5SbkMXyCFBJ2L40oimBstPIFRMQ6IOgb2AW7XEYWEjmLZEO8K4Sd5tg9dv5v/t1ihhhFp9PZHA6HlwCWx3s5f99LpdJxvV5/zubleGGt7QFYA/AF4BHAZx4AqrpEcgdABcC7iKxMAlAnrqobjUbDweQWxpgqyRcHISI/RTuBrAMO4E5EarkpZxJZa7sA9n0A1yJyVBDAFYDDABAcCA4EB4IDwYHgQHAgOOBzoEfyoYiWTFV3AVR9AEVo/8o5FYBkdzAYxD6KKIpuALhe30UrTdNT35lyuZyoas3nwExdsTGmRXJ7JHouImc+AGvtP+iK3RXEcXzgq2ae/0mS3M5yBf00TdebzebbPCKTzrTb7dUoil4BLEx7A+PhtK+q9yTdkPrnUNUKyT0Ai1OHU2PMFsmLAsfzD5IncRw/Zav6Bp2eNzAj2a47AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/icon-phone.png
// module id = 6uX0
// module chunks = 28